import { Controller } from "@hotwired/stimulus"
import { post, getSlideUrl } from '../helpers'

export default class extends Controller {
  static classes = ['accepted']
  static values = { acceptUrl: String }

  async accept({ params }) {
    const query = { url: getSlideUrl() }

    if (params.permanent) {
      query.permanent = '1'
    }

    this.element.classList.add(this.acceptedClass)

    await post(this.acceptUrlValue, { query })
  }
}
